module.exports = __webpack_public_path__ + "static/media/hero.19de5298.png";